// extracted by mini-css-extract-plugin
module.exports = {"dropdown-pagesize":"dropdownPageSize_dropdown-pagesize__2aIO8"};